import React from "react";

export const SendIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="30"
      height="30"
    >
      <path
        d="M54 20 L10 30 L26 56 Z"
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M54 20 L24 38 L10 30"
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M24 38 L26 56"
        fill="none"
        stroke="#fff"
        strokeWidth="3.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const BStarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 60"
      width="35"
      height="35"
    >
      <path
        d="M 23 15 L 19 24 L 7 31 L 18 37 L 23 48 L 27 38 L 40 31 L 30 27 Z"
        fill="#000"
      />
      <path
        d="M 39 10 L 36 14 L 32 15 L 37 19 L 38 22 L 39 19 L 44 16 L 39 12 Z"
        fill="#000"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 60"
      width="30"
      height="30"
    >
      <path
        d="M 23 15 L 19 24 L 7 31 L 18 37 L 23 48 L 27 38 L 40 31 L 30 27 Z"
        fill="#fff"
      />
      <path
        d="M 39 10 L 36 14 L 32 15 L 37 19 L 38 22 L 39 19 L 44 16 L 39 12 Z"
        fill="#fff"
      />
    </svg>
  );
};

export const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <ellipse cx="256" cy="256" rx="256" ry="256" />
      <path
        d="m376.5 251.7c2.4 1.4 3.2 4.5 1.8 6.9-0.4 0.7-1.1 1.4-1.8 1.8l-176 103c-2.4 1.4-5.5 0.6-6.9-1.8-0.4-0.8-0.7-1.6-0.7-2.5v-206.1c0-2.8 2.3-5 5-5 0.9 0 1.7 0.2 2.5 0.7l176.1 103z"
        fill="#fff"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#181818"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="11" cy="11" r="7"></circle>
      <line x1="16.65" y1="16.65" x2="21" y2="21"></line>
    </svg>
  );
};

interface DateIconProps {
  isActive?: boolean;
}

const DateIcon: React.FC<DateIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33333H4.16667C3.24619 3.33333 2.5 4.07952 2.5 5V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V5C17.5 4.07952 16.7538 3.33333 15.8333 3.33333Z"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33333H17.5"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 11.53333H17.5"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 14.63333H17.5"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 1.66667V5"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 1.66667V5"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10V17.6667"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10V17.6667"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10V17.6667"
        stroke={isActive ? "#c9b077" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DateIcon;

export const BackIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M10 19l-7-7 7-7" />
      <path d="M3 12h38" />
    </svg>
  );
};

export const ListIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* <circle cx="5" cy="7" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="5" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="5" cy="17" r="1.5" fill="currentColor" stroke="none" /> */}
      <line x1="3" y1="7" x2="20" y2="7" />
      <line x1="3" y1="12" x2="20" y2="12" />
      <line x1="3" y1="17" x2="20" y2="17" />
    </svg>
  );
};
